import Icon from "@components/ui/icon";
import { useEffect } from "react";
import { toast } from "react-toastify";

export const useUpdateBillingSuccessToast = () => {
  useEffect(() => {
    const showToast = localStorage.getItem("updated-billing-details");
    if (!showToast) return;
    localStorage.removeItem("updated-billing-details");
    toast.success(
      <div className="tw-flex tw-items-center">
        <div className="tw-flex tw-flex-col tw-text-left tw-leading-tight">
          Your billing details were updated successfully!
          <span className="tw-font-light">Happy storytelling!</span>
        </div>
        <button
          className="tw-ml-6 hover:tw-opacity-80 tw-transition-opacity tw-cursor-pointer"
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            toast.dismiss();
          }}
        >
          <Icon icon="ri-close-fill" />
        </button>
      </div>,
      {
        toastId: "update-billing-success-toast",
      },
    );
  }, []);
};
